import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { NgModule, LOCALE_ID } from '@angular/core';
import { NgbModule, NgbDateAdapter } from '@ng-bootstrap/ng-bootstrap';
import { AccordionModule } from 'ngx-bootstrap';
import { TabsModule } from 'ngx-bootstrap';
import { AgmCoreModule } from '@agm/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { MacroService } from './shared/services/macro.service';
import { FechaService } from './shared/fecha/fecha.service';
import { GeolocalizacionService } from './shared/ubicacion/geolocalizacion.service';
import { FullCalendarModule } from 'ng-fullcalendar';
import { LoadingComponent } from './loading/loading.component';
import { AlertComponent } from './alerta/alerta.component';
import { AlertaService } from './alerta/alerta.service';
import { PorFormularioComponent } from './actividades/por-formulario/por-formulario.component';
import { SlideMenuModule } from 'cuppa-ng2-slidemenu/cuppa-ng2-slidemenu';
import { AppRoutingModule } from './shared/app-routing.module';
import { ModalModule } from 'ngx-bootstrap';
import { DataTableModule } from './shared/data-table';
import { DragulaModule } from 'ng2-dragula';
import { FirmaComponent } from './utilidades/firma/firma.component';

import { StorageServiceModule} from 'angular-webstorage-service';
import { SessionTerminarComponent } from './session/terminar/sessionterminar.component';
import { SessionIniciarComponent } from './session/iniciar/sessioniniciar.component';
import { Utilities } from './shared/utilities';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PorFormularioGuard } from './actividades/por-formulario/por-formulario.guard';

import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';

// Registra el locale 'es' para español
registerLocaleData(localeEs);

@NgModule({
  declarations: [
    AppComponent,
    LoadingComponent,
    AlertComponent,
    PorFormularioComponent,
    SessionTerminarComponent,
    SessionIniciarComponent,
    FirmaComponent
  ],
  imports: [
    BrowserModule,
    StorageServiceModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    FullCalendarModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBA35Ho3xRzuGpTCyOiDuADdHPmkNv0rr8',
      libraries: ['places']
    }),
    NgbModule.forRoot(),
    SlideMenuModule,
    AppRoutingModule,
    ModalModule.forRoot(),
    DataTableModule,
    DragulaModule,
    CKEditorModule,
    BsDropdownModule.forRoot(),
    AccordionModule.forRoot(),
    TabsModule.forRoot()

  ],
  exports: [],
  providers: [
    MacroService,
    AlertaService,
    FechaService,
    GeolocalizacionService,
    Utilities,
    PorFormularioGuard,
    {
        provide: LOCALE_ID,
        useValue: 'es'
    }
],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts